import OriginRichTextArea from './RichTextArea';
import { richTextAreaStore } from './store';
import { RichTextAreaStaticFunction } from './types';

type RichTextAreaType = typeof OriginRichTextArea & RichTextAreaStaticFunction;

const RichTextArea = OriginRichTextArea as RichTextAreaType;

RichTextArea.getRef = function (id: string) {
  return richTextAreaStore.getRef(id);
};

export default RichTextArea;
